import type { IPhoneDataProvider } from '@/entities/common/types/phones';

const defaultDoctorPhone: IPhoneDataProvider['doctors'] = [
  {
    id: 1,
    name: 'Default Doctor',
    phones: [
      {
        answerRatePercentage: 60,
        phone: '+77773332211,010203',
        providedServiceType: 5,
      },
    ],
  },
];

const defaultMedcenterPhone: IPhoneDataProvider['medcenters'] = [
  {
    id: 1,
    name: 'Default Medcenter',
    phones: [
      {
        answerRatePercentage: 70,
        phone: '+77771119966,030201',
        providedServiceType: 5,
      },
    ],
  },
];

export const genPhonesDoctor = (
  doctorPhone?: IPhoneDataProvider['doctors'],
  medcenterPhone?: IPhoneDataProvider['medcenters'],
): IPhoneDataProvider => {
  return {
    doctors: doctorPhone || defaultDoctorPhone,
    medcenters: medcenterPhone || defaultMedcenterPhone,
  };
};
